// 20220112170906
// https://api.github.com/users/mahfod-dev/repos?per_page=100

export default [
	{
		id: 434648750,
		node_id: 'R_kgDOGeg2rg',
		name: 'countriesreact',
		full_name: 'Mahfod-dev/countriesreact',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/countriesreact',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/countriesreact',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/countriesreact/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/countriesreact/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/countriesreact/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/countriesreact/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/countriesreact/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/countriesreact/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/countriesreact/deployments',
		created_at: '2021-12-03T15:43:21Z',
		updated_at: '2021-12-03T15:43:55Z',
		pushed_at: '2021-12-03T15:43:52Z',
		git_url: 'git://github.com/Mahfod-dev/countriesreact.git',
		ssh_url: 'git@github.com:Mahfod-dev/countriesreact.git',
		clone_url: 'https://github.com/Mahfod-dev/countriesreact.git',
		svn_url: 'https://github.com/Mahfod-dev/countriesreact',
		homepage: null,
		size: 375,
		stargazers_count: 2,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 385357715,
		node_id: 'MDEwOlJlcG9zaXRvcnkzODUzNTc3MTU=',
		name: 'DEVCONNECTOR',
		full_name: 'Mahfod-dev/DEVCONNECTOR',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/DEVCONNECTOR',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/DEVCONNECTOR/deployments',
		created_at: '2021-07-12T19:15:46Z',
		updated_at: '2021-07-14T23:35:08Z',
		pushed_at: '2021-07-14T23:35:05Z',
		git_url: 'git://github.com/Mahfod-dev/DEVCONNECTOR.git',
		ssh_url: 'git@github.com:Mahfod-dev/DEVCONNECTOR.git',
		clone_url: 'https://github.com/Mahfod-dev/DEVCONNECTOR.git',
		svn_url: 'https://github.com/Mahfod-dev/DEVCONNECTOR',
		homepage: null,
		size: 66,
		stargazers_count: 4,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 395117446,
		node_id: 'MDEwOlJlcG9zaXRvcnkzOTUxMTc0NDY=',
		name: 'ECOMMERCE',
		full_name: 'Mahfod-dev/ECOMMERCE',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/ECOMMERCE',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/forks',
		keys_url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/ECOMMERCE/deployments',
		created_at: '2021-08-11T21:10:35Z',
		updated_at: '2021-08-12T18:59:02Z',
		pushed_at: '2021-08-12T18:59:00Z',
		git_url: 'git://github.com/Mahfod-dev/ECOMMERCE.git',
		ssh_url: 'git@github.com:Mahfod-dev/ECOMMERCE.git',
		clone_url: 'https://github.com/Mahfod-dev/ECOMMERCE.git',
		svn_url: 'https://github.com/Mahfod-dev/ECOMMERCE',
		homepage: null,
		size: 3176,
		stargazers_count: 2,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 429505100,
		node_id: 'R_kgDOGZm6TA',
		name: 'exerciceJS-algo',
		full_name: 'Mahfod-dev/exerciceJS-algo',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/exerciceJS-algo',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/exerciceJS-algo/deployments',
		created_at: '2021-11-18T16:39:13Z',
		updated_at: '2021-11-18T16:39:19Z',
		pushed_at: '2021-11-18T17:28:33Z',
		git_url: 'git://github.com/Mahfod-dev/exerciceJS-algo.git',
		ssh_url: 'git@github.com:Mahfod-dev/exerciceJS-algo.git',
		clone_url: 'https://github.com/Mahfod-dev/exerciceJS-algo.git',
		svn_url: 'https://github.com/Mahfod-dev/exerciceJS-algo',
		homepage: null,
		size: 2,
		stargazers_count: 1,
		watchers_count: 0,
		language: null,
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 428188922,
		node_id: 'R_kgDOGYWk-g',
		name: 'forkify-mvc',
		full_name: 'Mahfod-dev/forkify-mvc',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/forkify-mvc',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/forkify-mvc',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/forkify-mvc/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/forkify-mvc/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/forkify-mvc/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/forkify-mvc/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/forkify-mvc/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/forkify-mvc/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/forkify-mvc/deployments',
		created_at: '2021-11-15T08:55:05Z',
		updated_at: '2021-11-15T09:03:10Z',
		pushed_at: '2021-11-15T09:03:07Z',
		git_url: 'git://github.com/Mahfod-dev/forkify-mvc.git',
		ssh_url: 'git@github.com:Mahfod-dev/forkify-mvc.git',
		clone_url: 'https://github.com/Mahfod-dev/forkify-mvc.git',
		svn_url: 'https://github.com/Mahfod-dev/forkify-mvc',
		homepage: null,
		size: 2240,
		stargazers_count: 6,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 5,
		open_issues: 0,
		watchers: 0,
		default_branch: 'master',
	},
	{
		id: 446123345,
		node_id: 'R_kgDOGpdNUQ',
		name: 'LocationGoogle',
		full_name: 'Mahfod-dev/LocationGoogle',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/LocationGoogle',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/LocationGoogle',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/LocationGoogle/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/LocationGoogle/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/LocationGoogle/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/LocationGoogle/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/LocationGoogle/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/LocationGoogle/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/LocationGoogle/deployments',
		created_at: '2022-01-09T15:13:00Z',
		updated_at: '2022-01-09T15:15:15Z',
		pushed_at: '2022-01-09T15:15:13Z',
		git_url: 'git://github.com/Mahfod-dev/LocationGoogle.git',
		ssh_url: 'git@github.com:Mahfod-dev/LocationGoogle.git',
		clone_url: 'https://github.com/Mahfod-dev/LocationGoogle.git',
		svn_url: 'https://github.com/Mahfod-dev/LocationGoogle',
		homepage: null,
		size: 6,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 3,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 397700415,
		node_id: 'MDEwOlJlcG9zaXRvcnkzOTc3MDA0MTU=',
		name: 'PROSHOP',
		full_name: 'Mahfod-dev/PROSHOP',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/PROSHOP',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/forks',
		keys_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/statuses/{sha}',
		languages_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/{archive_format}{/ref}',
		downloads_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/issues{/number}',
		pulls_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/notifications{?since,all,participating}',
		labels_url: 'https://api.github.com/repos/Mahfod-dev/PROSHOP/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/PROSHOP/deployments',
		created_at: '2021-08-18T18:33:12Z',
		updated_at: '2022-01-04T10:39:30Z',
		pushed_at: '2022-01-10T19:30:34Z',
		git_url: 'git://github.com/Mahfod-dev/PROSHOP.git',
		ssh_url: 'git@github.com:Mahfod-dev/PROSHOP.git',
		clone_url: 'https://github.com/Mahfod-dev/PROSHOP.git',
		svn_url: 'https://github.com/Mahfod-dev/PROSHOP',
		homepage: null,
		size: 1061,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 8,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 431153920,
		node_id: 'R_kgDOGbLjAA',
		name: 'quizzJs',
		full_name: 'Mahfod-dev/quizzJs',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/quizzJs',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/quizzJs',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/forks',
		keys_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/statuses/{sha}',
		languages_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/{archive_format}{/ref}',
		downloads_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/issues{/number}',
		pulls_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/notifications{?since,all,participating}',
		labels_url: 'https://api.github.com/repos/Mahfod-dev/quizzJs/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/quizzJs/deployments',
		created_at: '2021-11-23T15:29:34Z',
		updated_at: '2021-11-23T15:33:30Z',
		pushed_at: '2021-11-23T15:33:27Z',
		git_url: 'git://github.com/Mahfod-dev/quizzJs.git',
		ssh_url: 'git@github.com:Mahfod-dev/quizzJs.git',
		clone_url: 'https://github.com/Mahfod-dev/quizzJs.git',
		svn_url: 'https://github.com/Mahfod-dev/quizzJs',
		homepage: null,
		size: 1,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 435424448,
		node_id: 'R_kgDOGfQMwA',
		name: 'reactgitproject',
		full_name: 'Mahfod-dev/reactgitproject',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/reactgitproject',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/reactgitproject',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/reactgitproject/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/reactgitproject/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/reactgitproject/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/reactgitproject/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/reactgitproject/deployments',
		created_at: '2021-12-06T08:55:48Z',
		updated_at: '2021-12-06T09:30:47Z',
		pushed_at: '2021-12-06T09:30:44Z',
		git_url: 'git://github.com/Mahfod-dev/reactgitproject.git',
		ssh_url: 'git@github.com:Mahfod-dev/reactgitproject.git',
		clone_url: 'https://github.com/Mahfod-dev/reactgitproject.git',
		svn_url: 'https://github.com/Mahfod-dev/reactgitproject',
		homepage: null,
		size: 345,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 442869414,
		node_id: 'R_kgDOGmWmpg',
		name: 'SHOP_CLOTHING',
		full_name: 'Mahfod-dev/SHOP_CLOTHING',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/SHOP_CLOTHING',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/SHOP_CLOTHING/deployments',
		created_at: '2021-12-29T19:20:54Z',
		updated_at: '2022-01-03T17:26:06Z',
		pushed_at: '2022-01-11T15:45:51Z',
		git_url: 'git://github.com/Mahfod-dev/SHOP_CLOTHING.git',
		ssh_url: 'git@github.com:Mahfod-dev/SHOP_CLOTHING.git',
		clone_url: 'https://github.com/Mahfod-dev/SHOP_CLOTHING.git',
		svn_url: 'https://github.com/Mahfod-dev/SHOP_CLOTHING',
		homepage: null,
		size: 377,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 439579595,
		node_id: 'R_kgDOGjNzyw',
		name: 'testProjectNissim',
		full_name: 'Mahfod-dev/testProjectNissim',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/testProjectNissim',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/testProjectNissim',
		forks_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/collaborators{/collaborator}',
		teams_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/teams',
		hooks_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/issues/events{/number}',
		events_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/testProjectNissim/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/compare/{base}...{head}',
		merges_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/testProjectNissim/deployments',
		created_at: '2021-12-18T09:51:28Z',
		updated_at: '2021-12-20T09:19:34Z',
		pushed_at: '2021-12-20T09:19:31Z',
		git_url: 'git://github.com/Mahfod-dev/testProjectNissim.git',
		ssh_url: 'git@github.com:Mahfod-dev/testProjectNissim.git',
		clone_url: 'https://github.com/Mahfod-dev/testProjectNissim.git',
		svn_url: 'https://github.com/Mahfod-dev/testProjectNissim',
		homepage: null,
		size: 217270,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
	{
		id: 433865927,
		node_id: 'R_kgDOGdxExw',
		name: 'youtubeReact',
		full_name: 'Mahfod-dev/youtubeReact',
		private: false,
		owner: {
			login: 'Mahfod-dev',
			id: 62814940,
			node_id: 'MDQ6VXNlcjYyODE0OTQw',
			avatar_url: 'https://avatars.githubusercontent.com/u/62814940?v=4',
			gravatar_id: '',
			url: 'https://api.github.com/users/Mahfod-dev',
			html_url: 'https://github.com/Mahfod-dev',
			followers_url: 'https://api.github.com/users/Mahfod-dev/followers',
			following_url:
				'https://api.github.com/users/Mahfod-dev/following{/other_user}',
			gists_url: 'https://api.github.com/users/Mahfod-dev/gists{/gist_id}',
			starred_url:
				'https://api.github.com/users/Mahfod-dev/starred{/owner}{/repo}',
			subscriptions_url:
				'https://api.github.com/users/Mahfod-dev/subscriptions',
			organizations_url: 'https://api.github.com/users/Mahfod-dev/orgs',
			repos_url: 'https://api.github.com/users/Mahfod-dev/repos',
			events_url: 'https://api.github.com/users/Mahfod-dev/events{/privacy}',
			received_events_url:
				'https://api.github.com/users/Mahfod-dev/received_events',
			type: 'User',
			site_admin: false,
		},
		html_url: 'https://github.com/Mahfod-dev/youtubeReact',
		description: null,
		fork: false,
		url: 'https://api.github.com/repos/Mahfod-dev/youtubeReact',
		forks_url: 'https://api.github.com/repos/Mahfod-dev/youtubeReact/forks',
		keys_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/keys{/key_id}',
		collaborators_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/collaborators{/collaborator}',
		teams_url: 'https://api.github.com/repos/Mahfod-dev/youtubeReact/teams',
		hooks_url: 'https://api.github.com/repos/Mahfod-dev/youtubeReact/hooks',
		issue_events_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/issues/events{/number}',
		events_url: 'https://api.github.com/repos/Mahfod-dev/youtubeReact/events',
		assignees_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/assignees{/user}',
		branches_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/branches{/branch}',
		tags_url: 'https://api.github.com/repos/Mahfod-dev/youtubeReact/tags',
		blobs_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/git/blobs{/sha}',
		git_tags_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/git/tags{/sha}',
		git_refs_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/git/refs{/sha}',
		trees_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/git/trees{/sha}',
		statuses_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/statuses/{sha}',
		languages_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/languages',
		stargazers_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/stargazers',
		contributors_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/contributors',
		subscribers_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/subscribers',
		subscription_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/subscription',
		commits_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/commits{/sha}',
		git_commits_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/git/commits{/sha}',
		comments_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/comments{/number}',
		issue_comment_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/issues/comments{/number}',
		contents_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/contents/{+path}',
		compare_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/compare/{base}...{head}',
		merges_url: 'https://api.github.com/repos/Mahfod-dev/youtubeReact/merges',
		archive_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/{archive_format}{/ref}',
		downloads_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/downloads',
		issues_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/issues{/number}',
		pulls_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/pulls{/number}',
		milestones_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/milestones{/number}',
		notifications_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/notifications{?since,all,participating}',
		labels_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/labels{/name}',
		releases_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/releases{/id}',
		deployments_url:
			'https://api.github.com/repos/Mahfod-dev/youtubeReact/deployments',
		created_at: '2021-12-01T14:45:50Z',
		updated_at: '2021-12-02T08:49:03Z',
		pushed_at: '2021-12-02T08:49:01Z',
		git_url: 'git://github.com/Mahfod-dev/youtubeReact.git',
		ssh_url: 'git@github.com:Mahfod-dev/youtubeReact.git',
		clone_url: 'https://github.com/Mahfod-dev/youtubeReact.git',
		svn_url: 'https://github.com/Mahfod-dev/youtubeReact',
		homepage: null,
		size: 378,
		stargazers_count: 0,
		watchers_count: 0,
		language: 'JavaScript',
		has_issues: true,
		has_projects: true,
		has_downloads: true,
		has_wiki: true,
		has_pages: false,
		forks_count: 0,
		mirror_url: null,
		archived: false,
		disabled: false,
		open_issues_count: 0,
		license: null,
		allow_forking: true,
		is_template: false,
		topics: [],
		visibility: 'public',
		forks: 0,
		open_issues: 0,
		watchers: 0,
		default_branch: 'main',
	},
]
